import React, { useState, useEffect,useRef } from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import {
  Card,
  CardContent,
  Grid,
  Typography,
  Switch,
  Box,
  Chip,
  TextField,
  Button,
  OutlinedInput,
  FormControl,
  Select,
  FormGroup,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import ReactQuill from 'react-quill-new';
import { useParams } from "react-router-dom";
import 'react-quill-new/dist/quill.snow.css'; // Import theme CSS
import DeleteIcon from "@mui/icons-material/Delete";
import { IconButton } from "@mui/material";
import { FaEnvelope } from "react-icons/fa";
import SoftButton from "components/SoftButton";
import CircularProgress from "@mui/material/CircularProgress";
import MenuItem from "@mui/material/MenuItem";
import { Check } from "@mui/icons-material";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import StorefrontIcon from "@mui/icons-material/Storefront";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import { useNavigate } from "react-router-dom";
import { customerEmails, getEmailSettings, saveEmailTemplate, editEmailTemplate } from "api/apiService";
import { notify, notifyCenter } from "utils/toast";

function EmailSettings() {
  const selectRef = useRef(null);
  const navigate = useNavigate();
  const [enabled, setEnabled] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [open, setOpen] = useState(false);
  const [selectedEmailType, setSelectedEmailType] = useState(""); // initially empty
  const { templateId } = useParams(); // rename 'id' to match your route param
  const isEditMode = !!templateId;

  // `status`-kolonnen ble fjernet — den ble aldri lest av dispatch-logikken;
  // automation-regler styrer hvilken mal som sendes når.
  const [formData, setFormData] = useState({
    email_type: "",        // 1st select input (E-posttype)
    template_name: "",     // 2nd input (E-postmalens navn)
    subject: "",           // 3rd input (Emne)
    send_to: [],           // 4th input (Checkboxes: Admin, Vendor, Customer)
    message: "",           // 5th input (Rich text editor)
    prevent_duplicates: true, // toggle (per-template duplicate-skip)
  });

  console.log('templateId',templateId);
  console.log('selectedEmailType',selectedEmailType);

  const roleIcons = {
    admin: <AdminPanelSettingsIcon />,
    vendor: <StorefrontIcon />,
    customer: <PeopleAltIcon />,
  };

  const emailTypes = [
    { value: "order_creation", full_name: "Order Creation" },
    { value: "status_change", full_name: "Status Change" },
    { value: "price_change_by_admin", full_name: "Price Change By Admin" },
    { value: "custom", full_name: "Custom" },
  ];

  useEffect(() => {
    if (isEditMode) {
      const fetchTemplate = async () => {
        try {
          setIsLoading(true);
          const res = await editEmailTemplate(templateId);
          if (res.status && res.data) {
            const t = res.data;
            setFormData({
              email_type: t.email_type,
              template_name: t.template_name,
              subject: t.subject,
              message: t.message,
              send_to: Array.isArray(t.send_to) ? t.send_to : [],
              prevent_duplicates: t.prevent_duplicates !== false,
            });
            setSelectedEmailType(t.email_type);
          } else {
            
            notifyCenter("error", "Kunne ikke hente e-postmal.", { duration: 2000 });
          }
          setIsLoading(false);
        } catch (err) {
          console.error("Fetch edit template error", err);
          notifyCenter("error", "Noe gikk galt ved henting.", { duration: 2000 });
          setIsLoading(false);
        }
      };

      fetchTemplate();
    }
  }, [templateId]);


  const handleInputClick2 = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = () => {
    setOpen(false);
  };

  
  const handleToggle = async () => {
    const newValue = !enabled;
    setEnabled(newValue);
    setIsLoading(true);
    try {
      const res = await customerEmails(newValue);
      notifyCenter("success", "Innstillinger lagret", { duration: 2000 });
      setIsLoading(false);
    } catch (err) {
      notifyCenter("error", "Noe gikk galt under lagringen", { duration: 3000 });
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const fetchSettings = async () => {
      setIsLoading(true);
      try {
        const result = await getEmailSettings();
        setEnabled(!!result.customer_emails);
        setIsLoading(false);
      } catch (err) {
        notifyCenter("error", "Kunne ikke hente e-postinnstillinger", { duration: 3000 });
        setIsLoading(false);
      }
    };
    fetchSettings();
  }, []);

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: files ? files[0] : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Build final data first
    const fullData = {
      ...formData,
      email_type: selectedEmailType,
    };

    // Now validate from fullData
    const { email_type, template_name, subject, message, send_to } = fullData;
    const missingFields = [];

    if (!email_type) missingFields.push("email_type");
    if (!template_name) missingFields.push("template_name");
    if (!subject) missingFields.push("subject");
    if (!message) missingFields.push("message");
    if (!send_to || send_to.length === 0) missingFields.push("send_to");

    if (missingFields.length > 0) {
      console.log("❌ Missing fields:", missingFields);
      notifyCenter("warning", "Vennligst fyll ut alle obligatoriske felt.", { duration: 3000 });
      return;
    }

    if (isEditMode) {
      fullData.template_id = templateId;
    }

    console.log("📤 Email Template Data to Submit:", fullData);
    setIsLoading(true);

    try {
      const response = await saveEmailTemplate(fullData);
      console.log("✅ Email template saved:", response);
      setIsLoading(false);

      if (response.status === true) {
        notifyCenter("success", isEditMode ? "E-postmalen ble oppdatert!" : "E-postmalen ble lagret!", { duration: 2000 });
        setTimeout(() => {
          navigate("/email-settings");  // ✅ redirect to the email templates page
        }, 1000);
      } else {
        notifyCenter("error", "Noe gikk galt. Prøv igjen.", { duration: 3000 });
      }

    } catch (error) {
      console.error("❌ Error saving email template:", error);
      notifyCenter("error", "Feil ved lagring av e-postmal.", { duration: 3000 });
      setIsLoading(false);
    }
  };







  return (
    <DashboardLayout>
      {isLoading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(255, 255, 255, 0.98)",
            zIndex: 1000,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <CircularProgress size={100} color="info" />
        </div>
      )}
      <Typography variant="h4" mb={3}>
        Epostinnstillinger
      </Typography>

      {/* Email Toggle */}
      <Card
        sx={{
          backgroundColor: "#fff",
          p: 3,
          mb: 3,
          borderRadius: 3,
          boxShadow: "0 4px 12px rgba(0,0,0,0.04)",
          position: "relative",
          overflow: "visible",
        }}
      >
        <Chip
          label={enabled ? "PÅ" : "AV"}
          size="small"
          sx={{
            position: "absolute",
            top: -8,
            right: -8,
            zIndex: 1,
            background: enabled
              ? "#98ec2d"
              : "#ccc",
            color: "#fff",
          }}
        />

        <Grid container alignItems="center" justifyContent="space-between">
          <Grid item display="flex" alignItems="center" gap={1}>
            <Box
              sx={{
                backgroundColor: "#0066b7",
                color: "#fff",
                minWidth: "2rem",
                minHeight: "2rem",
                borderRadius: "0.5rem",
                display: "grid",
                placeItems: "center",
                boxShadow: `
                  0rem 0.25rem 0.375rem -0.0625rem rgba(0, 0, 0, 0.12),
                  0rem 0.125rem 0.25rem -0.0625rem rgba(0, 0, 0, 0.08)
                `,
                transition: "margin 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
              }}
            >
              <FaEnvelope size={14} />
            </Box>
            <Typography variant="subtitle1" fontWeight={500}>
              Kundemeldinger
            </Typography>
          </Grid>
          <Grid item>
            {enabled !== null && (
              <Switch checked={enabled} onChange={handleToggle} color="primary" />
            )}
          </Grid>
        </Grid>
      </Card>

      {/* Compose Email Form */}
      <Card
        sx={{
          backgroundColor: "#fff",
          p: 3,
          mb: 3,
          borderRadius: 3,
          boxShadow: "0 4px 12px rgba(0,0,0,0.04)",
          position: "relative",
          overflow: "visible",
        }}
      >
        <Typography variant="h6" mb={2}>
          Send E-post
        </Typography>

        <form onSubmit={handleSubmit}>
          <Grid container spacing={2}>

            <Grid item xs={12}>
              <FormControl sx={{ width: "100%" }}>
                <Select
                  displayEmpty
                  value={selectedEmailType}
                  onChange={(e) => setSelectedEmailType(e.target.value)}
                  input={<OutlinedInput onClick={handleInputClick2} />}
                  sx={{
                    height: "40px !important",
                    cursor: "pointer",
                  }}
                  renderValue={(selected) => {
                    if (!selected) {
                      return (
                        <Typography
                          variant="body1"
                          style={{ fontSize: "14px", fontWeight: "normal", margin: "-11px", color: "#aab1c3"}}
                        >
                          E-posttype
                        </Typography>
                      );
                    }
                    const selectedItem = emailTypes.find((type) => type.value === selected);
                    return (
                      <Typography variant="body1" style={{ fontSize: "14px", fontWeight: "normal", margin: "-11px"}}>
                        {selectedItem?.full_name}
                      </Typography>
                    );
                  }}
                  inputProps={{ "aria-label": "Send email to" }}
                  ref={selectRef}
                  open={open}
                  onClose={handleClose}
                  onClick={(e) => {
                    e.stopPropagation();
                    setOpen(!open);
                  }}
                >
                  <MenuItem disabled value="">
                    <Typography variant="body1" style={{ fontSize: "14px", fontWeight: "normal",}}>
                      <em>E-posttype</em>
                    </Typography>
                  </MenuItem>
                  {emailTypes.map((type) => (
                    <MenuItem key={type.value} value={type.value}>
                      <Typography variant="body1" style={{ fontSize: "14px", fontWeight: "normal" }}>
                        {type.full_name}
                      </Typography>
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            {/* template_name */}
            <Grid item xs={12}>
              <TextField
                fullWidth
                placeholder="E-postmalens navn"
                name="template_name"
                value={formData.template_name}
                onChange={handleChange}
                variant="outlined"
                InputProps={{
                  sx: {
                    padding: '10px 14px !important', // Adjust padding to ensure text visibility
                    '& input': {
                      width: 'calc(100% - 0px) !important', // Adjust input width to prevent text cutoff
                    }
                  }
                }}
              />
            </Grid>

            {/* Subject */}
            <Grid item xs={12}>
              <TextField
                fullWidth
                placeholder="Emne"
                name="subject"
                value={formData.subject}
                onChange={handleChange}
                variant="outlined"
                InputProps={{
                  sx: {
                    padding: '10px 14px !important', // Adjust padding to ensure text visibility
                    '& input': {
                      width: 'calc(100% - 0px) !important', // Adjust input width to prevent text cutoff
                    }
                  }
                }}
              />
            </Grid>

            <Grid item xs={12}>
              <Typography variant="body2" fontWeight="bold" mb={1}>
                Send e-post til:
              </Typography>

              <Grid container spacing={2}>
                {["admin", "vendor", "customer"].map((role) => {
                  const isSelected = formData.send_to.includes(role);

                  return (
                    <Grid item xs={12} sm={4} key={role}>
                      <Box
                        onClick={() => {
                          const updatedList = isSelected
                            ? formData.send_to.filter((item) => item !== role)
                            : [...formData.send_to, role];

                          setFormData((prev) => ({
                            ...prev,
                            send_to: updatedList,
                          }));
                        }}
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          border: `1.5px solid ${isSelected ? "#1976d2" : "#ccc"}`,
                          borderRadius: 2,
                          px: 1.5,
                          py: 1.2,
                          cursor: "pointer",
                          backgroundColor: isSelected ? "#e3f2fd" : "#fff",
                          transition: "0.2s ease-in-out",
                          "&:hover": {
                            backgroundColor: isSelected ? "#bbdefb" : "#f9f9f9",
                          },
                        }}
                      >
                        <Box display="flex" alignItems="center" gap={1}>
                          <Box
                            sx={{
                              backgroundColor: "#1976d2",
                              color: "#fff",
                              borderRadius: "50%",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              width: 30,
                              height: 30,
                              fontSize: 18,
                            }}
                          >
                            {roleIcons[role]}
                          </Box>
                          <Typography fontWeight="bold" variant="body2">
                            {role.charAt(0).toUpperCase() + role.slice(1)}
                          </Typography>
                        </Box>

                        <Box
                          sx={{
                            width: 22,
                            height: 22,
                            borderRadius: "6px",
                            border: "2px solid #ccc",
                            backgroundColor: isSelected ? "#1e293b" : "#fff",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            color: "#fff",
                          }}
                        >
                          {isSelected && <Check fontSize="small" sx={{ fontSize: 14 }} />}
                        </Box>
                      </Box>
                    </Grid>
                  );
                })}
              </Grid>
            </Grid>




            <Grid item xs={12}>
              <Box mb={2} p={2} sx={{ backgroundColor: "#f4f6f8", borderRadius: "8px" }}>
                <Typography variant="body2" fontWeight="bold" mb={1}>
                  Tilgjengelige variabler (kopier og lim inn i meldingen):
                </Typography>
                <Typography variant="body2" sx={{ wordBreak: "break-word", fontFamily: "monospace" }}>
                  {'{{customer_name}}, {{vendor_name}}, {{project_link_customer}}, {{project_link_vendor}}, {{order_invoice}}, {{order_payment_link}}, {{order_payment_button}}, {{delivery_day}}, {{delivery_date}}, {{delivery_time}}, {{customer_phone_number}}, {{admin_phone_number}}, {{volume}}, {{concrete_quality}}, {{truck_type}}, {{delivery_address}}'}
                </Typography>
              </Box>
            </Grid>

            {/* Message */}
            <Grid item xs={12}>
              <ReactQuill
                theme="snow"
                value={formData.message}
                onChange={(value) =>
                  setFormData((prev) => ({ ...prev, message: value }))
                }
                style={{
                  borderRadius: '12px',
                  backgroundColor: '#fff',
                }}
                placeholder="Skriv meldingen din her..."
              />
            </Grid>

            {/* Forhindre duplikater per template — admin styrer per mal om
                samme type skal hoppes over hvis den allerede er sendt for
                samme ordre. Manuelle e-poster sendes uansett. */}
            <Grid item xs={12}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  padding: "12px 16px",
                  border: "1px solid #e0e0e0",
                  borderRadius: "10px",
                  backgroundColor: "#fafafa",
                  gap: 2,
                }}
              >
                <Box>
                  <Typography sx={{ fontSize: 14, fontWeight: 600, color: "#000" }}>
                    Forhindre dupliserte e-poster
                  </Typography>
                  <Typography sx={{ fontSize: 12, color: "#6b7280" }}>
                    Hopp over automatisk sending hvis denne maltypen
                    (<code>{selectedEmailType || "—"}</code>) allerede er sendt
                    for samme ordre. Manuelle sendinger er ikke berørt.
                  </Typography>
                </Box>
                <Switch
                  checked={!!formData.prevent_duplicates}
                  onChange={(e) =>
                    setFormData((prev) => ({
                      ...prev,
                      prevent_duplicates: e.target.checked,
                    }))
                  }
                  color="primary"
                />
              </Box>
            </Grid>

            {/* Submit */}
            <Grid item xs={12}>


              <SoftButton variant="gradient" color="info" type="submit">
                {isEditMode ? "OPPDATER" : "LAGRE"}
              </SoftButton>

            </Grid>
          </Grid>
        </form>

      </Card>
    </DashboardLayout>
  );
}

export default EmailSettings;
